<template>
  <div >
    <el-collapse v-model="activeNames" @change="changeList" accordion>
      <el-collapse-item  v-for="item in server" :key="item.key" :name="item.id">
         <template slot="title" style="font-size:24px">
          <i style="margin-right:6px" class="el-icon-s-unfold" ></i>{{item.name}}
        </template>
         <el-button
          v-if="activeNames == helpId"
          icon="el-icon-circle-plus-outline"
          type="primary"
          style="margin-left:20px;"
          @click="addDoctor"
        >新增专家</el-button>
        <el-button
          icon="el-icon-circle-plus-outline"
          type="primary"
          style="margin-left:20px;"
          @click="addProgram"
        >新增项目</el-button>
       <el-row  v-loading="loading"  
       element-loading-text="加载中"
      >
         <el-col>
        <el-row :gutter="60" >
          <el-col :span="4" v-for="item in tableList" :key="item.id" style="margin-top:20px;height:260px">
            <img v-if="!item.imgsCode" style="width:100%;height:100px" src="@/assets/common/program.png" alt />
            <img v-else style="width:100%;height:100px" :src="item.imgsCode" alt />
            <div style="font-size: 22px;font-weight: bold;">{{item.merchandiseName}}</div>
            <div style="color:red;font-size: 18px;">￥{{item.unitPrice}}</div>
             <div>
              <span v-if="item.isPutaway == true">上架</span>
              <span v-else>下架</span>
              <el-switch
                v-model="item.isPutaway"
                active-color="#13ce66"
                @change='changeOnOff(item)'>
              </el-switch>
            </div>
            <el-tooltip   class="item" effect="dark" :disabled="item.remark.length<10" :content="item.remark" placement="top-start">
              <div class="world">{{item.remark}}</div>
            </el-tooltip>
            <div style="display:flex;margin-top:6px">
              <el-button
                size="mini"
                icon="el-icon-edit"
                type="warning"
                @click="fix(item)"
              >修改</el-button>
              <el-button
                size="mini"
                icon="el-icon-delete"
                type="danger"
                @click="delet(item)"
              >删除</el-button>
            </div>
          </el-col>
        </el-row>

          <!-- 专家 -->
         <el-row :gutter="60" v-if="activeNames == helpId">
          <el-col :span="4" v-for="item in doctorList" :key="item.id" style="margin-top:20px;height:260px">
            <img v-if="!item.imgsCode" style="width:100%;height:100px" src="@/assets/common/program.png" alt />
            <img v-else style="width:100%;height:100px" :src="item.imgsCode" alt />
            <div>姓名：{{item.specialistName}}</div>
            <div>性别：{{item.gender ==0?'男':'女'}}</div>
            <div>年龄：{{item.age}}</div>
            <div>医院：{{item.hospital}}</div>
            <div>擅长：{{item.speciality}}</div>
            <div>科室：{{item.administrative}}</div>
            <div style="display:flex;margin-top:6px">
              <el-button
                size="mini"
                icon="el-icon-edit"
                type="warning"
                @click="fixDoctor(item)"
              >修改</el-button>
              <el-button
                size="mini"
                icon="el-icon-delete"
                type="danger"
                @click="deletDoctor(item)"
              >删除</el-button>
            </div>
          </el-col>
        </el-row>
        </el-col>
        </el-row>

      </el-collapse-item>
    </el-collapse>

    <!-- 商品弹窗 -->
    <el-dialog
      :title="isAdd?'新增':'修改'"
      width="600px"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      @close="closeDialogReset"
    >
      <el-form
        :model="addForm"
        label-width="120px"
        :rules="dataFormRules"
        ref="dataForm"
        label-position="right"
      >
        <el-row type="flex" justify="center">
          <el-col>
            <el-row>
              <el-col :span="24">
                <el-form-item label="项目名称:" prop="merchandiseName">
                  <el-input v-model.trim="addForm.merchandiseName" class="width220"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="项目费用:" prop="unitPrice">
                  <el-input v-model.trim="addForm.unitPrice" class="width220">
                    <template slot="append">元</template>
                  </el-input>
                  <el-input v-model.trim="addForm.times" class="times"></el-input>
                  <el-select clearable v-model="addForm.type" class="type">
                    <el-option
                      v-for="item in typeList"
                      :key="item.type"
                      :label="item.name"
                      :value="item.type"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="上传图片:" prop="imgsCode">
                  <el-upload
                    class="avatar-uploader"
                    action="string"
                    accept="image/png, image/jpeg"
                    :show-file-list="false"
                    list-type="picture-card"
                    :before-upload="beforeUpload"
                    :http-request="upload"
                  >
                    <img
                      style="width:100%;height:100%"
                      v-if="addForm.imgsCode"
                      :src="addForm.imgsCode"
                      class="avatar"
                    />
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="项目介绍:" prop="remark">
                  <el-input type="textarea" :rows="4" v-model.trim="addForm.remark" class="width220"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" align="center">
        <el-button @click.native="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click.native="submitForm">确定</el-button>
      </div>
    </el-dialog>

    <!-- 专家弹窗 -->
    <!-- <el-dialog
      :title="isAddDoctor?'新增专家':'修改专家'"
      width="32%"
      :visible.sync="doctorDialogVisible"
      :close-on-click-modal="false"
      @close="closeDialogDoctor"
    >
      <el-form
        :model="doctorForm"
        label-width="120px"
        :rules="doctorFormRules"
        ref="doctorForm"
        label-position="right"
      >
        <el-row type="flex" justify="center">
          <el-col>
            <el-row>
              <el-col :span="20">
                <el-form-item label="姓名:" prop="specialistName">
                  <el-input v-model.trim="doctorForm.specialistName"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="20">
                <el-form-item label="性别:" prop="gender">
                  <el-radio-group  v-model="doctorForm.gender">
                    <el-radio :label="0">男</el-radio>
                    <el-radio :label="1">女</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="20">
                <el-form-item label="上传图片:">
                  <el-upload
                    class="avatar-uploader"
                    action="string"
                    accept="image/png, image/jpeg"
                    :show-file-list="false"
                    list-type="picture-card"
                    :before-upload="beforeUpload"
                    :http-request="upload"
                  >
                    <img
                      style="width:100%;height:100%"
                      v-if="doctorForm.imgsCode"
                      :src="doctorForm.imgsCode"
                      class="avatar"
                    />
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="20">
                <el-form-item label="年龄:" prop="age">
                  <el-input v-model.trim="doctorForm.age"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="20">
                <el-form-item label="医院:" prop="hospital">
                  <el-input v-model.trim="doctorForm.hospital"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
             <el-row>
              <el-col :span="20">
                <el-form-item label="擅长:" prop="speciality">
                  <el-input v-model.trim="doctorForm.speciality"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
             <el-row>
              <el-col :span="20">
                <el-form-item label="科室:" prop="administrative">
                  <el-input v-model.trim="doctorForm.administrative"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" align="center">
        <el-button @click.native="doctorDialogVisible = false">取消</el-button>
        <el-button type="primary" @click.native="submitDoctorForm">确定</el-button>
      </div>
    </el-dialog> -->

    <!-- 新增专家 -->
    <el-dialog
      :title="isAddDoctor?'新增专家项目':'修改专家项目'"
      width="980px"
      :visible.sync="doctorDialogVisible"
      :close-on-click-modal="false"
      @close="closeDialogDoctor"
    >
      <el-form
        :model="doctorForm"
        label-width="120px"
        :rules="doctorFormRules"
        ref="doctorForm"
        label-position="right"
      >
        <el-row type="flex" justify="flex-start" style="border-bottom:1px solid #ccc;margin-bottom:15px">
          <el-col :span="9">
            <el-row>
              <el-col :span="20">
                <el-form-item label="姓名:" prop="specialistName">
                  <el-input v-model.trim="doctorForm.specialistName" style="width:145px;"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="20">
                <el-form-item label="性别:" prop="gender">
                  <el-radio-group  v-model="doctorForm.gender">
                    <el-radio :label="0">男</el-radio>
                    <el-radio :label="1">女</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="20">
                <el-form-item label="上传图片:">
                  <el-upload
                    class="avatar-uploader"
                    action="string"
                    accept="image/png, image/jpeg"
                    :show-file-list="false"
                    list-type="picture-card"
                    :before-upload="beforeUpload"
                    :http-request="upload"
                  >
                    <img
                      style="width:100%;height:100%"
                      v-if="doctorForm.imgsCode"
                      :src="doctorForm.imgsCode"
                      class="avatar"
                    />
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="8" style="margin-top:45px;">
            <el-row>
              <el-col :span="20">
                <el-form-item label="年龄:" prop="age">
                  <el-input v-model.trim="doctorForm.age" style="width:145px;"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="20">
                <el-form-item label="医院:" prop="hospital">
                  <el-input v-model.trim="doctorForm.hospital" style="width:145px;"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
             <el-row>
              <el-col :span="20">
                <el-form-item label="擅长:" prop="speciality">
                  <el-input v-model.trim="doctorForm.speciality" style="width:145px;"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
             <el-row>
              <el-col :span="20">
                <el-form-item label="科室:" prop="administrative">
                  <el-input v-model.trim="doctorForm.administrative" style="width:145px;"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <el-row style="display:flex;justify-content:flex-start;align-items:center;flex-wrap:wrap;width:100%;margin-bottom:10px;">
            <div v-for="(item,index) in doctorForm.doctorFormList" :key="index" style="width:50%">
            <el-row>
              <el-col :span="24">
                <el-form-item label="项目名称:" :prop="'doctorFormList.' + index +'.merchandiseName'"  :rules="[{required: true, message: '不能为空'}]">
                  <el-input v-model.trim="item.merchandiseName" style="width:145px;"></el-input>
                  <i v-if="index==0" class="el-icon-circle-plus-outline" style="color:blue" @click="addDoctorForm"></i>
                  <i v-if="index>0" class="el-icon-remove-outline" style="color:blue" @click="removeDoctorForm(item,index)"></i>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="15">
                <el-form-item label="项目费用:" :prop="'doctorFormList.' + index +'.unitPrice'" :rules="[{required: true, message: '不能为空'}]">
                  <el-input v-model.trim="item.unitPrice" style="width:145px;">
                    <template slot="append">元</template>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-form-item label="" label-width="0" :prop="'doctorFormList.' + index +'.times'" :rules="[{required: true, message: '不能为空'}]">
                <el-input v-model.trim="item.times" class="times"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item label="" label-width="0" :prop="'doctorFormList.' + index +'.type'" :rules="[{required: true, message: '不能为空'}]">
                <el-select clearable v-model="item.type" class="type">
                    <el-option
                      v-for="item2 in typeList"
                      :key="item2.type"
                      :label="item2.name"
                      :value="item2.type"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="上传图片:" :prop="'doctorFormList.' + index +'.imgsCode'"  :rules="[{required: true, message: '不能为空'}]">
                  <el-upload
                    class="avatar-uploader"
                    action="string"
                    accept="image/png, image/jpeg"
                    :show-file-list="false"
                    list-type="picture-card"
                    :before-upload="beforeUpload"
                    :http-request="upload"
                  >
                    <img
                      style="width:100%;height:100%"
                      v-if="item.imgsCode"
                      :src="item.imgsCode"
                      class="avatar"
                    />
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="项目介绍:" :prop="'doctorFormList.' + index +'.remark'"  :rules="[{required: true, message: '不能为空'}]">
                  <el-input type="textarea" :rows="4" v-model.trim="item.remark" style="width:145px;"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            </div>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" align="center">
        <el-button @click.native="doctorDialogVisible = false">取消</el-button>
        <el-button type="primary" @click.native="submitDoctorForm">确定</el-button>
      </div>
    </el-dialog>

  </div>
</template>
<script>
export default {
    data(){
        return{
            isAdd:true,
            activeNames:'',
            server:[],
            tableList:[],
            dialogVisible:false,
            doctorDialogVisible:true, //专家
            addForm:{
                merchandiseName:'',
                unitPrice:'',
                imgsCode:'',
                remark:"",
                firstLevelId:'',
            },
            businessId:'',  //商家id
            dataFormRules:{
                merchandiseName:[
                    { required: true, message: '不能为空', trigger: 'blur' },
                    {min:1,max:10,message:'长度在1到10个字符', trigger: 'blur' }
                ],
                unitPrice:[
                    { required: true, message: '不能为空', trigger: 'blur' },
                    { pattern: /^(\d+)(.\d{0,2})?$/,message:'最多输入小数点后两位',trigger: 'blur'},
                    {min:1,max:10,message:'长度在1到10个字符',trigger: 'blur'}
                ],
                remark:[
                    {min:0,max:300,message:'长度在0到300个字符', trigger: 'blur' }
                ],
            },
           doctorForm:{
                specialistName:'',
                gender:'',
                age:'',
                hospital:'',
                administrative:'',
                speciality:'',
                imgsCode:'',
                doctorFormList:[
                  {
                    merchandiseName:'',
                    unitPrice:'',
                    times:'',
                    type:'',
                    imgsCode:'',
                    remark:"",
                  }
                ],
           },
           
            doctorFormRules:{
                specialistName:[
                  { required: true, message: '不能为空', trigger: 'blur' },
                  {min:1,max:10,message:'长度在1到10个字符',trigger: 'blur' }
                  ], 
                gender:[
                    { required: true, message: '不能为空', trigger: 'change' },
                  ],
                age:[
                    { required: true, message: '不能为空', trigger: 'blur' },
                     { pattern: /^([0]|[1-9][0-9]*)$/,message:'请输入正整数',trigger: 'blur'},
                     {min:1,max:3,message:'长度在1到3个字符'}
                  ],
                hospital:[
                    { required: true, message: '不能为空', trigger: 'blur' },
                    {min:1,max:15,message:'长度在1到15个字符',trigger: 'blur' }
                  ],
                administrative:[
                    { required: true, message: '不能为空', trigger: 'blur' },
                    {min:1,max:15,message:'长度在1到15个字符',trigger: 'blur' }
                  ],
                speciality:[
                    { required: true, message: '不能为空', trigger: 'blur' },
                    {min:1,max:15,message:'长度在1到15个字符',trigger: 'blur' }
                  ],
            },
            id:'',
            doctorList:[], //专家数据
            isAddDoctor:true,
            doctorId:'',//专家id
            helpId:'',
            loading:true,
            typeList:[
              {
                type:1,
                name:'次/月'
              },
              {
                type:2,
                name:'小时'
              },
              {
                type:3,
                name:'张'
              },
              {
                type:4,
                name:'件'
              },
            ],
        }
    },
    methods:{
        //添加专家的项目
        addDoctorForm() {
          this.doctorForm.doctorFormList.push({
              specialistName:'',
              gender:'',
              age:'',
              hospital:'',
              administrative:'',
              speciality:'',
              imgsCode:''
            },)
          console.log(this.doctorForm.doctorFormList)
        },

        //删除专家的项目
        removeDoctorForm(item,index) {
          console.log(item,index);
          this.doctorForm.doctorFormList.splice(index,1);
        },

        //获取服务列表
         getServer(){
            this.server = []
            this.$postForm("uac/merchant/selectLevelId",{id:this.businessId}).then(res =>{
              res.result.forEach(item =>{
                this.$postJson('omc/merchandis/selectServiceFirstLevel',{firstLevelIds:[item.firstLevelId]}).then(res =>{
                this.server.push({
                  id:item.firstLevelId,
                  name:res.result[0].name
                })
                if(res.result[0].name == '助医'){
                   this.helpId = item.firstLevelId
                }
              })
              })
            })
            },

            //上架下架
            changeOnOff(item){
              console.log(item)
              //上架
              if(item.isPutaway){
                this.$postForm('omc/merchandis/on',{id:item.id}).then(res=>{
                  if(res.code ==200){
                    this.$message({message:'上架成功',type:"success"})
                    this.getTableList()
                  }else{
                    this.$message({message:res.message,type:"error"})
                  }
                })
              }else{//下架
                 this.$postForm('omc/merchandis/off',{id:item.id}).then(res=>{
                  if(res.code ==200){
                    this.$message({message:'下架成功',type:"success"})
                    this.getTableList()
                  }else{
                    this.$message({message:res.message,type:"error"})
                  }
                })
              }
              //下架
            },
            


        //添加项目
        addProgram(){
          this.isAdd =true
            this.dialogVisible =true
        },

        //数据上传
        submitForm(){
            this.$refs.dataForm.validate((valid) => {
              if (valid) {
                   if(this.isAdd){
                      let param = this.addForm
                      param.firstLevelId = this.activeNames
                      param.merchantId = this.businessId
                      this.$postJson('omc/merchandis/add',param).then(res =>{
                          if(res.code ==200){
                            this.dialogVisible = false
                            this.getTableList()
                            this.$message({message:res.message,type:'success'})
                          }else{
                            this.$message({message:res.message,type:'error'})
                          }
                      })
                   }else{
                     let param = this.addForm
                      param.firstLevelId = this.activeNames
                      param.merchantId = this.businessId
                      param.id = this.id
                      this.$postJson('omc/merchandis/update',param).then(res =>{
                          if(res.code ==200){
                            this.dialogVisible = false
                            this.getTableList()
                            this.$message({message:res.message,type:'success'})
                          }else{
                            this.$message({message:res.message,type:'error'})
                          }
                      })
                   }
              } else {
                return false;
              }
        });
        },

        //上传图片
            upload(param){
            var fileObj = param.file;
            if (fileObj != undefined) {
                // FormData 对象
                var form = new FormData();
                // 文件对象
                form.append("file", fileObj);
                form.append("fileType", "picture");
                form.append("bucketName", "cmny-oss");
                console.log(form);
                this.$postFormData("opc/file/uploadFile", form).then(res => {
                if (res.code == 200) {
                    this.$postForm('opc/file/queryAttachmentById/'+res.result).then(res =>{
                      if(this.activeNames ==this.helpId){
                        this.doctorForm.imgsCode = "http://51cs8.com/" + res.result.path + res.result.name
                      }else{
                        this.addForm.imgsCode = "http://51cs8.com/" + res.result.path + res.result.name
                      }
                        })
                    this.$message({message:res.message,type:'success'})
                } else {
                    this.$message({
                    type: "error",
                    message: res.message
                    });
                }
                });
            }
    },

     /* 
      图片验证
    */
    beforeUpload(file) {
      console.log(file);
      let isPNG = false;
      file.type == "image/gif" ? (isPNG = false) : (isPNG = true);
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isPNG) {
        this.$message.error("上传图片格式不能是 gif 格式");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB");
      }
      return isPNG && isLt2M;
    },

    //点击折叠面板
    changeList(){
        this.getDoctor()
        this.getTableList()
    },

     //查询列表
     getTableList(){
       let param ={
         pageNum:1,
         pageSize:999,
         firstLevelId:this.activeNames,
         merchantId:this.businessId
       }
         this.$postJson('omc/merchandis/select',param).then(res =>{
             this.tableList = res.result.list
             this.tableList.map(item =>{
               item.isPutaway==0?item.isPutaway =true:item.isPutaway==1?item.isPutaway =false:''
               return item
             })
         })
     },
        //查询商家id
        getBusiness(){
            this.$postForm('uac/merchant/haveId').then(res =>{
                this.businessId = res.result
                 this.getServer()
            })
        },

        //关闭弹窗
        closeDialogReset(){
            this.$refs.dataForm.resetFields(); //移除校验结果并重置字段值
            this. addForm={
                merchandiseName:'',
                unitPrice:'',
                imgsCode:'',
                remark:"",
                firstLevelId:'',
            }
        },

        //修改
        fix(row){
            this.isAdd = false
            this.dialogVisible = true
            this.addForm = JSON.parse(JSON.stringify(row))
            this.addForm.unitPrice = String(row.unitPrice)
            this.id = row.id
        },

        //删除
        delet(row){
            this.$confirm('是否删除此条数据?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center:true
        }).then(() => {
            this.$postForm('omc/merchandis/delete',{id:row.id}).then(res =>{
                if(res.code ==200){
                    this.$message({type: 'success',message: '删除成功!'});
                    this.getTableList()
                }else{
                  this.$message({type: 'error',message: res.message});
                }
            })
        })   
        },

        //增加专家
        addDoctor(){
          this.doctorDialogVisible = true
          this.isAddDoctor = true
        },

        //提交专家数据
        submitDoctorForm(){
            this.$refs.doctorForm.validate((valid) => {
              if (valid) {
                   if(this.isAddDoctor){
                  let param =this.doctorForm
                    param.merchantId = this.businessId 
                    this.$postJson('omc/specialist/add',param).then(res =>{
                      if(res.code ==200){
                        this.$message({type: 'success',message: res.message});
                        this.doctorDialogVisible = false
                        this.getDoctor()
                      }else{
                        this.$message({type: 'error',message: res.message});
                      }
                    })
                }else{
                      let param = this.doctorForm
                      param.id = this.doctorId
                      this.$postJson('omc/specialist/update',param).then(res =>{
                        if(res.code ==200){
                          this.$message({type: 'success',message: res.message});
                          this.doctorDialogVisible = false
                          this.getDoctor()
                        }else{
                          this.$message({type: 'error',message: res.message});
                        }
                      })
                }
              } else {
                return false;
              }
            })
         
         
        },

        //查询专家
        getDoctor(){
          this.loading = true
          this.$postJson('omc/specialist/select',{merchantId:this.businessId}).then(res =>{
            this.doctorList = res.result.list
            setTimeout(() => {
              this.loading = false
            }, 1000);
          })
        },

        //修改专家
        fixDoctor(row){
          this.isAddDoctor = false
          this.doctorDialogVisible = true
          this.doctorForm = JSON.parse(JSON.stringify(row))
           this.doctorForm.age = String(this.doctorForm.age)
          this.doctorId = row.id
        },

        //删除专家
        deletDoctor(row){
           this.$confirm('是否删除该专家?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
            center:true
          }).then(() => {
              this.$postForm('omc/specialist/delete',{id:row.id}).then(res =>{
                  if(res.code ==200){
                      this.$message({type: 'success',message: '删除成功!'});
                      this.getDoctor()
                  }else{
                      this.$message({type: 'error',message: res.message});
                  }
              })
          })   
        },

        //关闭专家弹窗
        closeDialogDoctor(){
          this.$refs.doctorForm.resetFields(); //移除校验结果并重置字段值
          this.doctorForm ={}
        },
    },
    mounted(){
        this.getBusiness()
       
    },
}
</script>
<style lang="scss" scoped>
::deep .el-collapse-item__header{
  font-size: 18px;
}
.remark{
  width: 100%;
}
.world{
  height: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.width220{
  width:220px;
}
.times{
  width:70px;
}
.type{
  width:90px;
}
::deep .el-radio{
  height: 40px;
  line-height: 40px;
}
</style>